import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function StickyMobile() {
  const { t } = useTranslation("home");
  const location = useLocation();

  const isEmergencyPage =
    location.pathname.includes("/slotenmaker-eindhoven/") ||
    location.pathname.includes("/inbraakschade-reparatie/");

  const phoneDisplay = isEmergencyPage ? "06 38 27 20 35" : "040 798 7470";
  const phoneHref = isEmergencyPage ? "tel:+31638272035" : "tel:+31407987470";

  return (
    <a
      href={phoneHref}
      className="md:hidden fixed bottom-4 left-4 right-4 z-[200] h-14 font-geist font-bold text-base bg-brand-yellow text-brand-text rounded-full shadow-lg flex items-center justify-center gap-2.5 whitespace-nowrap hover:bg-white active:scale-[0.98] transition-all"
      aria-label={`Bel direct ${phoneDisplay}`}
    >
      <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-lg"></i>
      <span>Bel direct</span>
      <span className="font-geist-mono">{phoneDisplay}</span>
    </a>
  );
}